<script setup lang="ts">
import EpIconButton from '~/components/button/EpIconButton.vue'
import SearchResult from '~/components/header/general-search/SearchResult.vue'
import SearchBar from '~/components/search/SearchBar.vue'
import { useGeneralSearch } from '~/composables/useGeneralSearch'
import { useMedia } from '~/composables/useMedia'

const emits = defineEmits([ 'update:setMobileSearchOpen', 'update:setSidebarOpen' ])

const inputModel = ref<string>('')

const { resultMap, isFetching, moveToOnlyResult } = useGeneralSearch(inputModel)

const { isDesktop } = useMedia()

watchEffect(() => {
  if (isDesktop.value) {
    inputModel.value = ''
  }
})
</script>

<template>
  <div class="mobile-search-container">
    <div class="mobile-search-input">
      <EpIconButton
        icon-name="west"
        :icon-size="20"
        :value="false"
        @click="emits('update:setMobileSearchOpen')"
      />
      <SearchBar
        placeholder="Search by Address, TX ID, Block"
        v-model="inputModel"
        @enter="moveToOnlyResult"
      />
    </div>
    <SearchResult
      class="result"
      :input-value="inputModel"
      :result-map="resultMap"
      :is-fetching="isFetching"
    />
  </div>
</template>

<style scoped lang="scss">
.mobile-search-input {
  @apply bg-black flex p-2 h-14 border-b-4;
  border-image: linear-gradient(90deg, #E99E52, #97D9D7, #E99E52) 1;
}

.result {
  height: 100vh;
}
</style>